import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContabilidadService } from '../../../services/service.index';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

declare function init_plugins();

@Component({
  selector: 'app-actualizacuentacontable',
  templateUrl: './actualizacuentacontable.component.html',
  styles: []
})
export class ActualizaCuentaContableComponent implements OnInit {

  forma: FormGroup;
  ido: string;
  cuenta: {
          account: '',
          accounting_key: '',
          accounting_name: '',
          accounting_type: '',
          assigment: '',
          center: '',
          cost_center: '',
          definition: '',
          pep_element: '',
          profit_center: '',
          tax_indicator: '',
          bank:''
        }
  banks: any[] = [];
  constructor(
    private route: ActivatedRoute,
    public _contabilidad: ContabilidadService,
    public router: Router
  ) { }


  ngOnInit() {
    Swal.fire({
      title: 'Cargando',
      allowOutsideClick: false
 });
    Swal.showLoading();
      this.ido = this.route.snapshot.paramMap.get('id');

      this.forma = new FormGroup({
        Name: new FormControl( null , Validators.required ),
        Descripcion: new FormControl( null , Validators.required )
      } );

      this._contabilidad.getCuentaContable( this.ido ).subscribe( resp => { Swal.close();
        this.cuenta = {
          account: resp[0] && resp[0].account ? resp[0].account : '',
          accounting_key: resp[0] && resp[0].accounting_key ? resp[0].accounting_key : '',
          accounting_name: resp[0] && resp[0].accounting_name ? resp[0].accounting_name : '',
          accounting_type: resp[0] && resp[0].accounting_type ? resp[0].accounting_type : '',
          assigment: resp[0] && resp[0].assigment ? resp[0].assigment : '',
          center: resp[0] && resp[0].center ? resp[0].center : '',
          cost_center: resp[0] && resp[0].cost_center ? resp[0].cost_center : '',
          definition: resp[0] && resp[0].definition ? resp[0].definition : '',
          pep_element: resp[0] && resp[0].pep_element ? resp[0].pep_element : '',
          profit_center: resp[0] && resp[0].profit_center ? resp[0].profit_center : '',
          tax_indicator: resp[0] && resp[0].tax_indicator ? resp[0].tax_indicator : '',
          bank: resp[0] && resp[0].bank ? resp[0].bank : ''
        }; 
        this._contabilidad.getPersonBank().subscribe( resp => {
        this.banks = resp.data.map( (bank: { attributes: any; }) => { return bank.attributes });
      });

      }
      ,(err) => {Swal.fire({title: 'Ocurrio un error al cargar la información', allowOutsideClick: false })} );

  }


  actualizaCuentaContable() {
  Swal.showLoading();
  const data = {
    ...this.cuenta
  };
    this._contabilidad.actualizaCuentaContable( this.ido, data).subscribe( () => {
    Swal.fire({
      title: 'Modificacion de cuenta contable exitosa',
      text: '',
      icon: 'success',
      showConfirmButton: true,
      showCancelButton: false,
      allowOutsideClick: false
    }). then ( res => {
      if ( res.value ) {
        this.router.navigate(['/contabilidad/cuentascontables']);
      }

    } );
  }, (err) => {
     Swal.fire(
       'Error al modificar la cuenta',
       'Error',
       'error'
    );
  } );
  }


}
